import {Component, signal} from '@angular/core';
import {TransfersService} from '../../services/transfers.service';
import {DatePipe, KeyValuePipe} from '@angular/common';
import {Utils} from '../../shared/utils';
import {debounceTime, Subscription} from 'rxjs';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {NbSpinnerModule} from "@nebular/theme";
import {TeamsService} from "../../services/teams.service";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-transfers',
  standalone: true,
  imports: [TranslateModule, KeyValuePipe, DatePipe, ReactiveFormsModule, NbSpinnerModule],
  templateUrl: './transfers.component.html',
  styleUrl: '../../shared/styles/transfers.component.scss'
})
export class TransfersComponent {
  preserveOrder = (a: any, b: any) => 0;
  transfersByDay = signal<any>({});
  currentUserTeamIds = signal<string[]>([]);

  obs!: Subscription;
  searchedValue: string = '';
  loading = signal<boolean>(false);

  searchForm: FormGroup = new FormGroup({
    searched_value: new FormControl()
  });

  constructor(public utils: Utils, protected teamsService: TeamsService, private transfersService: TransfersService) {}

  formatDay(dateKey: unknown): string {
    const locale = localStorage.getItem('locale') || 'en';
    return new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'long', day: 'numeric' }).format(new Date(dateKey as string));
  }

  ngOnInit(): void {
    this.loading.set(true);
    this.teamsService.currentUserTeamIds().subscribe(teamIds => {
      this.currentUserTeamIds.set(teamIds);
      this.search();
    });

    this.obs = this.searchForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.searchedValue = data.searched_value;
        this.search();
      });
  }

  ngOnDestroy() {
    this.obs.unsubscribe();
  }

  search() {
    this.loading.set(true);
    this.transfersService.transfers(this.searchedValue).pipe(debounceTime(15000)).subscribe((transfersByDay) => {
      this.transfersByDay.set(transfersByDay);
      this.loading.set(false);
    });
  }

  getTransfers(obj: any): any[] {
    return obj;
  }

  toDate(obj: any) {
    return new Date(obj);
  }

  protected readonly Object = Object;
}
